export default {
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "inherit",
    height: "inherit"
  }
};
